import React, { Fragment, Component } from 'react'
import {
    Container,
    Row, Col,
    CardBody, Card, CardTitle, CardSubtitle,
    Button,
    Input,
    Label,
    FormGroup, CustomInput,
    Table
} from "reactstrap"
import { ConfirmAlert } from '../../../../helpers/ui/alert'
import { AvForm, AvGroup, AvInput, AvField, AvCheckboxGroup, AvCheckbox } from "availity-reactstrap-validation"
import Select from "react-select"
import { FileInput, generateFormData } from '../../../../helpers/ui/FileInput'
import { Link, useHistory, Redirect } from "react-router-dom"
import { withRouter } from "react-router";

import apiResponse from '../../../../services/apiResponse'
import Shimmer from "react-shimmer-effect";
import CustomSelect from "../../../../helpers/ui/CustomSelect"

import CreateManualBlock from './Blocs/CreateManualBloc'

var reformatOptions = function(raw, label, value) {
    return raw.map(function(data) {
      var newObj = {};
      newObj["label"] = data[label];
      newObj["value"] = data[value];
  
      return newObj;
    });
};
var potonganoption = [
    {'label':'5%','value':5},
    {'label':'10%','value':10},
    {'label':'15%','value':15},
    {'label':'20%','value':20},
    {'label':'25%','value':25},
    {'label':'30%','value':30},
    {'label':'35%','value':35},
    {'label':'40%','value':40},
    {'label':'45%','value':45},
    {'label':'50%','value':50},
    {'label':'55%','value':55},
    {'label':'60%','value':60},
    {'label':'65%','value':65},
    {'label':'70%','value':70},
    {'label':'75%','value':75},
    {'label':'80%','value':80},
    {'label':'85%','value':85},
    {'label':'90%','value':90},
    {'label':'95%','value':95},
    {'label':'100%','value':100},
]
class IndexView extends Component {

    createManualBlock = new CreateManualBlock();

    constructor(props) {
        super(props)
        this.state = {
            dataForm: {},
            totalRow : null,
            employeeListOption: null,
            hukdisList: null,
        }
    }

    // submitData = async () => {
    //     await this.createManualBlock.fetchCreate(this.state.dataForm)
    // }
    submitData = async () => {
        const formData = generateFormData(this.state.dataForm, 'file_sk') // Jika nama field fileinputnya adalah 'File', maka parameter kedua boleh dikosongkan. Jika ada lebih dari 1 file input, maka gunakan array. conth: ['document', 'foto'] 
        // const formData = generateFormData(this.state.dataForm, ['file_sk','file_bap','file_lhp']) // Jika nama field fileinputnya adalah 'File', maka parameter kedua boleh dikosongkan. Jika ada lebih dari 1 file input, maka gunakan array. conth: ['document', 'foto'] 
        await this.createManualBlock.fetchCreate(formData)
    }

    handlerOnSubmit = (e, values) => {
        e.preventDefault()
        this.setState({
            dataForm: {
                uuid: this.state.detail?.punishment_discipline_uuid,
                ...values
            },
            confirm: true
        })
        console.log(values)
    }

    confirmResponse = (response) => {
        let forState = {}
        switch(response) {
            case 'cancel':
                forState = {
                    confirm: false
                }
                break;
            case 'confirm':
                forState = {
                    loading: true,
                    confirm: false
                }
                this.submitData()
                break;
            case 'success':
                forState = {
                    success: false,
                    redirect: true
                }
                break;
             case 'failed':
                forState = {
                    failed: false
                }
                break;
            default:       
        }
        this.setState(forState)
    }

    componentDidMount() {
        this.createManualBlock.createChannel.subscribe((result) => {
            switch (result.status) {
                case apiResponse.COMPLETED:
                    this.setState({
                        loading: false,
                        success: true,
                    });
                    break
                case apiResponse.ERROR:
                    this.setState({
                        loading: false,
                        failed: true,
                    });
                    break
                default:
                    break
            }
        })

        this.createManualBlock.detailChannel.subscribe((result) => {
            switch (result.status) {
                case apiResponse.COMPLETED:
                    if(result.data.status) {
                        let response = result.data.response
                        //console.log(response)
                        this.setState({
                            detail: response
                        })
                    }
                    break
                case apiResponse.ERROR:
                    
                    break
                default:
                    break
            }
        })

        const queryParams = new URLSearchParams(this.props.location.search)
        this.createManualBlock.fetchDetail({uuid: queryParams.get('uuid') })

        this.createManualBlock.employeeListChannel.subscribe((result) => {
            switch (result.status) {
              case apiResponse.COMPLETED:
                // this.setState({
                //   employeeListOption: result.data?.response?.result,
                // });
                console.log(reformatOptions(
                    result.data?.response?.result, 
                    'employee_name',
                    'employee_uuid'
                ))
                this.setState({
                    employeeListOption: reformatOptions(
                        result.data?.response?.result, 
                        'employee_name',
                        'employee_uuid'
                    )
                })
                break;
              case apiResponse.ERROR:
                break;
              default:
                break;
            }
        });
        this.createManualBlock.fetchEmployeeList();
        this.createManualBlock.hukdisListChannel.subscribe((result) => {
            switch (result.status) {
              case apiResponse.COMPLETED:
                // this.setState({
                //   employeeListOption: result.data?.response?.result,
                // });
                this.setState({
                    hukdisList: reformatOptions(
                        result.data?.response?.result, 
                        'punishment_namedesc',
                        'punishment_uuid'
                    )
                })
                break;
              case apiResponse.ERROR:
                break;
              default:
                break;
            }
        });
        this.createManualBlock.fetchHukdisList();
    }

    componentWillUnmount() {
        this.createManualBlock.createChannel?.unsubscribe()
        // this.createManualBlock.detailChannel?.unsubscribe()
    }

    render() {
        return (
            <Fragment>
                <Container fluid>
                    <Row>
                        <Col className="col-12">

                            <Card>
                                <CardBody>
                                    <CardTitle>Tindakan Pemanggilan</CardTitle>
                                    <CardSubtitle className="mb-3">
                                        Setiap isian yang bertanda (<span className="text-danger">*</span>) adalah wajib diisi.
                                    </CardSubtitle>
                                    <hr />
                                    <AvForm
                                        className="needs-validation"
                                        onValidSubmit={(e, values) => this.handlerOnSubmit(e, values)}
                                    >
                                        <Row className="mb-3">
                                            <label className="col-md-3">
                                                Periode Hukuman (Mulai s/d Selesai) <span className="text-danger">*</span>
                                            </label>
                                            <Col md="3">
                                                <AvField
                                                    name="periode_mulai"
                                                    placeholder="Tanggal Mulai"
                                                    errorMessage="Masukkan Tanggal Mulai"
                                                    type="date"
                                                    className="form-control"
                                                    // value={this.state.detail?.punishment_discipline_sp_date}
                                                    validate={{ required: { value: true } }}
                                                />
                                            </Col>
                                            <Col md="3">
                                                <AvField
                                                    name="periode_selesai"
                                                    placeholder="Tanggal Selesai"
                                                    errorMessage="Masukkan Tanggal Selesai"
                                                    type="date"
                                                    className="form-control"
                                                    // value={this.state.detail?.punishment_discipline_sp_date}
                                                    validate={{ required: { value: true } }}
                                                />
                                            </Col>
                                        </Row>
                                        <Row className="mb-3">
                                            <label className="col-md-3">
                                                Pegawai <span className="text-danger">*</span>
                                            </label>
                                            <Col md="6">
                                                <CustomSelect 
                                                    name="employee_uuid"
                                                    errorMessage="Pilih Pegawai"
                                                    options={this.state.employeeListOption} 
                                                    validate={{ required: { value: true } }}
                                                    placeholder="Pilih Pegawai"
                                                    // onChange={(v) =>{ 
                                                    //     this.setState({employeeuuid: v.value, redirect: true}, () => {
                                                    //         this.handleEmployeeChange();
                                                    //     });
                                                    // }}
                                                />
                                            </Col>
                                        </Row>
                                        <Row className="mb-3">
                                            <label className="col-md-3">
                                                Nomor SK <span className="text-danger">*</span>
                                            </label>
                                            <Col md="4">
                                            <AvField
                                                    name="no_sk"
                                                    placeholder="Nomor SK"
                                                    errorMessage="Masukkan Nomor SK"
                                                    type="text"
                                                    className="form-control"
                                                    // value={this.state.detail?.punishment_discipline_sp_number}
                                                    validate={{ required: { value: true } }}
                                                />
                                            </Col>
                                        </Row>
                                        <Row className="mb-3">
                                            <label className="col-md-3">
                                                TMT SK <span className="text-danger">*</span>
                                            </label>
                                            <Col md="4">
                                            <AvField
                                                    name="tmt_sk"
                                                    placeholder="TMT SK"
                                                    errorMessage="Masukkan TMT SK"
                                                    type="date"
                                                    className="form-control"
                                                    // value={this.state.detail?.punishment_discipline_sp_date}
                                                    validate={{ required: { value: true } }}
                                                />
                                            </Col>
                                        </Row>
                                        <Row className="mb-3">
                                            <label className="col-md-3">
                                                File SK <span className="text-danger">*</span>
                                            </label>
                                            <Col md="4">
                                                <FileInput
                                                    name="file_sk"
                                                    col="4"
                                                    validate={{ required: { value: true } }}
                                                />
                                            </Col>
                                        </Row>

                                        <Row className="mb-3">
                                            <label className="col-md-3">
                                                Hukuman Disiplin <span className="text-danger">*</span>
                                            </label>
                                            <Col md="6">
                                                <CustomSelect 
                                                    name="jenis_hukdis"
                                                    errorMessage="Pilih Hukuman"
                                                    options={this.state.hukdisList} 
                                                    validate={{ required: { value: true } }}
                                                    placeholder="Pilih Hukuman"
                                                />
                                            </Col>
                                        </Row>

                                        <Row className="mb-3">
                                            <label className="col-md-3">
                                                Potongan <span className="text-danger">*</span>
                                            </label>
                                            <Col md="6">
                                                <CustomSelect 
                                                    name="potongan"
                                                    errorMessage="Pilih Potongan"
                                                    options={potonganoption} 
                                                    validate={{ required: { value: true } }}
                                                    placeholder="Pilih Potongan"
                                                    // onChange={(v) =>{ 
                                                    //     this.setState({employeeuuid: v.value, redirect: true}, () => {
                                                    //         this.handleEmployeeChange();
                                                    //     });
                                                    // }}
                                                />
                                            </Col>
                                        </Row>

                                        
                                        <Row className="mb-3">
                                            <Col md="3"></Col>
                                            <Col md="9">
                                                <Link to="?">
                                                    <Button color="danger"><i className="uil-arrow-left"></i> Kembali</Button>
                                                </Link>
                                                {' '}
                                                <Button color="success" type="submit">
                                                    <i className="uil-arrow-up-right"></i> Simpan Data
                                                </Button>
                                            </Col>
                                        </Row>
                                    </AvForm>
                                </CardBody>
                            </Card>
                        </Col>
                    </Row>
                </Container>
                <ConfirmAlert
                    confirmTitle="Konfirmasi!"
                    confirmInfo="Data ini akan mempengaruhi pembayaran pada Tunjangan Kinerja pegawai. Mohon berhati-hati. Apakah Anda yakin akan melanjutkan proses ini?"

                    loadingTitle="Mengirim data..."
                    loadingInfo="Tunggu beberapa saat"

                    successTitle="Berhasil!"
                    successInfo="Data berhasil disimpan"

                    failedTitle="Gagal!"
                    failedInfo="Data gagal disimpan"

                    showConfirm={this.state.confirm}
                    showLoading={this.state.loading}
                    showSuccess={this.state.success}
                    showFailed={this.state.failed}

                    response={this.confirmResponse}
                />
                { this.state.redirect ?
                    <Redirect to='/kepegawaian/hukuman_disiplin.html?'/>
                : null }
            </Fragment>
        )
    }

}

//export default IndexView
export default withRouter(IndexView);